<script setup>
import { token_expired } from "@/assets/js/token_expired";
import axios from "axios";
import Swal from "sweetalert2";
import { ref, onMounted, defineEmits,computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router"
const router = useRouter();

const store = useStore();
const emits = defineEmits([
  "sbu_Ebook_open",
  "sbu_Ebook_guid",
  "sbu_Ebook_link",
  "sbu_Ebook_premium",
]);

const load = ref(false);

const info = ref([]);

const premium = ref(false);


function get_permissions() {
  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_account", localStorage.getItem("ac"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/teacher-info/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      console.log(response.data.data.series_permissions);

      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      response.data.data.series_permissions.forEach((item) => {
        if (item.series_name == localStorage.getItem("unit")) {
          if (item.ebooks == "premium") {
            premium.value = true;
          } else {
            premium.value = false;
          }
          return;
        }
      });
    })
    .catch((error) => {
      console.log(error);
      
      console.log(error.response.data.code);

      if (error.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }
    });
}

function get_info() {
  console.log("store.state.path",store.state.path);
  const level = localStorage.getItem("level");
  const choose = localStorage.getItem("choose");

  if (!level || !choose) {
    return;
  }

  const FormData = require("form-data");
  let data = new FormData();

  data.append("level", localStorage.getItem("level_type"));
  data.append("level_branch", localStorage.getItem("level_branch"));
  data.append("series_guid", localStorage.getItem("level_guid"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/ebooks-list/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      
      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.status == 520) {
        get_info();
      }

      token_expired(response);
      console.log(response);
      info.value = response.data.data;
      load.value = true;
    })
    .catch((error) => {
      console.log(error.response.data.code);

      if (error.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.status == 520) {
        get_info();
      }

      token_expired(error);
    });
}

function openBook(name, guid, premium) {
  emits("sbu_Ebook_name", name);
  emits("sbu_Ebook_open", true);
  emits("sbu_Ebook_guid", guid);
  emits("sbu_Ebook_premium", premium);
}

function adjustScale(element) {
  // 獲取當前的縮放比例
  const currentZoom = window.devicePixelRatio || 1;

  // 反向縮放，使之看起來像 100%
  const inverseZoom = 1 / currentZoom;

  // 使用 CSS transform 來反向縮放
  element.style.transform = `translate(-50%, -50%) scale(${inverseZoom})`;
  
}

const filteredInfo = computed(() => {
  // If premium is false, filter out the 'premium' items, otherwise return all items
  if (!premium.value&&info.value.length>0) {
    return info.value.filter(item => item.premium !== 'premium');
  } 
  return info.value;
});

onMounted(() => {
  get_permissions();
  get_info();
});
</script>

<template>
  <div style="position: relative; width: 100%; height: 100%">
    <div id="e_book" v-if="load">
      <div
        v-for="(item, index) in filteredInfo"
        :key="item.guid"
        :data-index="index"
        class="item"
        @click="openBook(item.subject, item.book_code, item.premium)"
      >
        <img
          v-if="item.premium == 'premium'"
          class="premium"
          src="../assets/images/e-book/premium.png"
          alt="icon"
        />
        <div class="pic">
          <img :src="item.cover" alt="pic" />
        </div>
        <h3>{{ item.subject }}</h3>
      </div>
    </div>
    <div
      v-if="!load"
      style="
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 25px;
      "
    >
      <h6
        style="
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          font-size: 60px;
          text-shadow: 0 5px 12px #888;
        "
      >
        LOADING...
      </h6>
    </div>
  </div>
</template>
